import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {AuthenticationService} from './authentication.service';
import {Usuario} from '../../usuarios/domain/usuario';

@Injectable()
export class SessionService {
    public usuario: Usuario;

    constructor(
        private http: HttpClient,
        private router: Router,
        private authentication: AuthenticationService
    ) {}
    startSession() {
        if (this.usuario.token !== null) {
            this.authentication.login(this.usuario);
        } else {
            this.authentication.logout();
        }
    }
    setUsuario(usuario) {
        this.usuario = new Usuario();
        this.usuario.id = usuario.id;
        this.usuario.cuenta = usuario.usuario;
        this.usuario.rol = usuario.rol;
        this.usuario.idiomas = usuario.idiomas;
        this.usuario.token = usuario.token;
    }
    getLoggedState() {
        return this.authentication.isAuthenticated();
    }
    initSession() {
        if (this.getLoggedState()) {
            return this.usuario;
        } else {
            this.router.navigate(['/']);
        }
    }
    endSession() {
        this.authentication.logout();
    }
}



// WEBPACK FOOTER //
// ./src/app/core/services/sessionService.ts